var React = require('react');

function Secure (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Secure"),React.createElement("path",{"fill":"#12ebae","d":"M0 1.2v16.004c0 3.277 1.848 6.002 4.265 8.29s5.449 4.305 8.238 6.29c0.196 0.137 0.438 0.218 0.7 0.218s0.505-0.082 0.704-0.221l-0.004 0.003c2.801-2 5.825-4.001 8.238-6.29s4.265-5.013 4.265-8.29v-16.004c-0.025-0.652-0.548-1.175-1.198-1.2l-0.002-0h-24.006c-0.635 0.065-1.135 0.565-1.2 1.195l-0 0.006zM2.401 2.401h21.605v14.804c0 2.377-1.344 4.469-3.525 6.554-2 1.912-4.661 3.721-7.278 5.565-2.613-1.844-5.277-3.653-7.278-5.565-2.181-2.085-3.525-4.177-3.525-6.554z","key":1})]);
}

Secure.defaultProps = {"version":"1.1","width":"26","height":"32","viewBox":"0 0 26 32"};

module.exports = Secure;

Secure.default = Secure;
